<template>
  <checkbox
    name="permissions"
    :required="true"
    :checked.sync="permissionCheckboxChecked"
    :input-error="inputError"
    @change="propagateChangeDown">
    {{{ permissionLabel }}}
  </checkbox>
  <slot name="afterCheckbox"></slot>
  <div class="newsletter__terms">
    <div class="newsletter__terms__in">
      <div class="newsletter__terms__header">
        {{ permissionTermsHeadline }}
      </div>
      <div class="newsletter__terms__text">
        <p>{{ permissionTerms }}</p>
        <p>Du kan til enhver tid afmelde dig kommunikationen. Du kan desuden begrænse dit samtykke her.</p>
        <p>{{{ permissionLabel }}} og ønsker at modtage:</p>
        <template v-for="(index, permission) in permissions">
          <checkbox
            :name="'permission-' + index"
            :value="permission.type"
            :checked.sync="permission.checked"
            @change="propagateChangeUp">
            {{ permission.label }}
          </checkbox>
        </template>
        <template v-for="(index, newsletter) in newsletters">
          <checkbox
            v-if="!newsletter.implicit"

            :name="'newsletter-' + index"
            :value="newsletter.type"
            :required="newsletter.required"
            :checked.sync="newsletter.checked"
            @change="propagateChangeUp">
            {{ newsletter.label }}
          </checkbox>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from './Checkbox.vue'

const configCollectionToCheckboxVm = (collection) => {
  return collection.map((item) => {
    return {
      type: item.type,
      label: item.label,
      checked: false,
      implicit: item.implicit
    }
  })
}

const vmToPermissionDto = (collection, brand) => {
  return collection.map((item) => {
    return {
      brand: brand,
      accepted: !!item.checked,
      sourceText: item.label,
      source: window.location.href,
      type: item.type
    }
  })
}

const vmToNewsletterDto = (collection) => {
  return collection.map((item) => {
    return {
      accepted: !!item.implicit || !!item.checked,
      type: item.type
    }
  })
}

export default {
  name: 'PermissionSection',
  components: [Checkbox],
  props: {
    newsletterConfig: {
      type: Array
    },
    permissionConfig: {
      type: Array
    },
    permissionBrand: {
      type: String
    },
    permissionLabel: {
      type: String
    },
    permissionTerms: {
      type: String
    },
    permissionTermsHeadline: {
      type: String,
      default: "Vilkår"
    },
    inputError: {
      type: Object
    }
  },
  data() {
    return {
      permissionCheckboxChecked: false,

      // PermissionService
      permissions: configCollectionToCheckboxVm(this.permissionConfig),
      // Peytz
      newsletters: configCollectionToCheckboxVm(this.newsletterConfig)
    }
  },
  methods: {
    propagateChangeDown(e) {
      this.permissions.forEach(function (item) {
        item.checked = e.target.checked
      })

      this.newsletters.forEach(function (item) {
        item.checked = e.target.checked
      })
    },
    propagateChangeUp(e) {
      if (e.target.checked) {
        this.permissionCheckboxChecked = true
      }
    },
    getFormData() {
      return {
        permissions: vmToPermissionDto(this.permissions, this.permissionBrand),
        newsletters: vmToNewsletterDto(this.newsletters)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// PermissionSection.vue?11e87520